export const MAX_ALLOWED_TITLE_LENGTH = 100;
export const MAX_ALLOWED_MESSAGE_SEGMENTS = 10;
// Backend limit for the message field (`message.length`), regardless of encoding.
export const MAX_ALLOWED_MESSAGE_LENGTH = 1000;

// GSM 03.38 default alphabet, laid out row by row (0x00-0x0F ... 0x70-0x7F),
// skipping 0x1B which is the escape code into the extension table below.
export const GSM_7_BASIC =
	'@£$¥èéùìòÇ\nØø\rÅå' +
	'Δ_ΦΓΛΩΠΨΣΘΞÆæßÉ' +
	' !"#¤%&\'()*+,-./' +
	'0123456789:;<=>?' +
	'¡ABCDEFGHIJKLMNO' +
	'PQRSTUVWXYZÄÖÑÜ§' +
	'¿abcdefghijklmno' +
	'pqrstuvwxyzäöñüà';

// GSM 03.38 extension table, reached via the 0x1B escape code.
export const GSM_7_EXTENDED = '\f^{}\\[~]|€';

export const TITLE_ERRORS = {
	TITLE_REQUIRED: 'Notification title is required.',
	TITLE_LENGTH_EXCEEDED: `Notification title must be less than ${MAX_ALLOWED_TITLE_LENGTH} characters.`,
};

export const MESSAGE_ERRORS = {
	MESSAGE_REQUIRED: 'Notification message is required.',
	MESSAGE_LENGTH_EXCEEDED: (maxLength) =>
		`Notification message must be less than ${maxLength} characters.`,
	MESSAGE_SEGMENTS_EXCEEDED: ({ totalLength, segments, encoding } = {}) => {
		const specialCharsNote =
			encoding === 'UCS-2'
				? ' Note: Emojis, accents, or special characters reduce segment capacity.'
				: '';

		return (
			`Message exceeds the limit, ${totalLength.toLocaleString()} characters used across ${segments} segments ` +
			`(max allowed: ${MAX_ALLOWED_MESSAGE_SEGMENTS} segments).${specialCharsNote}`
		);
	},
};

export const TEST_PHONE_NUMBER_ERRORS = {
	TEST_PHONE_NUMBER_REQUIRED: 'Test phone number is required.',
};